export enum OnBehalfType {
  Phone = 'tel',
  Fullname = 'text',
  Email = 'email',
  Optin = 'checkbox',
}
